import React from 'react';
import {Box} from '@chakra-ui/react';
import {SortableTable} from "../../../Portfolio/Components/sortableTable";

const PortfolioListListView = ({companies}) => {
    return (
        <Box position={'relative'}>
            <SortableTable companies={companies}/>
        </Box>
    );
};

export default PortfolioListListView;
